module.exports = __webpack_public_path__ + "static/media/matching-score-coin-80.ffcc1151.png";